export const contact = {
  hero: {
    title: 'Hablemos de tu proyecto',
    description: 'Cuéntanos sobre tu negocio y descubre cómo podemos ayudarte a automatizar tu gestión de citas. Te respondemos en menos de 24 horas.'
  },
  form: {
    title: 'Solicita información',
    namePlaceholder: 'Tu nombre completo',
    emailPlaceholder: 'tu@email.com',
    phonePlaceholder: '+34 600 000 000',
    companyPlaceholder: 'Nombre de tu clínica o negocio',
    messagePlaceholder: 'Cuéntanos qué necesitas...',
    success: 'Gracias, te contactaremos en menos de 24h.'
  },
  demo: {
    title: '¿Quieres una demo?',
    description: 'Agenda una demostración personalizada y descubre cómo nuestras soluciones pueden transformar tu negocio.'
  }
};
